import React from "react";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { List, Grid } from "lucide-react";

interface CustomToggleTabsProps {
  value: "list" | "grid";
  onChange: (value: "list" | "grid") => void;
}

const ToggleContainer = styled(Box)({
  width: "100%",
  backgroundColor: "#18181B",
  padding: "4px",
  borderRadius: "8px",
  display: "flex",
  gap: "4px",
  marginBottom: "16px",
  position: "relative"
});

interface SliderProps {
  $position: string;
}

const Slider = styled(Box)<SliderProps>(({ $position }) => ({
  position: "absolute",
  width: "calc(50% - 6px)",
  height: "calc(100% - 8px)",
  backgroundColor: "#22C55E",
  borderRadius: "6px",
  transition: "transform 0.3s ease-in-out",
  transform: $position === "left" ? "translateX(0)" : "translateX(100%)",
  left: "4px",
  top: "4px"
}));

const ToggleButton = styled(Box)<{ selected?: boolean }>(({ selected }) => ({
  flex: 1,
  padding: "8px",
  textAlign: "center",
  color: selected ? "#18181B" : "#FFFFFF",
  cursor: "pointer",
  borderRadius: "6px",
  position: "relative",
  zIndex: 1,
  transition: "color 0.2s ease-in-out",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "8px",
  fontWeight: selected ? 600 : 400,
  "&:hover": {
    backgroundColor: !selected ? "rgba(255, 255, 255, 0.1)" : "transparent"
  }
}));

export function CustomToggleTabs({ value, onChange }: CustomToggleTabsProps) {
  return (
    <ToggleContainer>
      <Slider $position={value === "list" ? "left" : "right"} />
      <ToggleButton
        selected={value === "list"}
        onClick={() => onChange("list")}
      >
        <List size={18} />
        Lista
      </ToggleButton>
      <ToggleButton
        selected={value === "grid"}
        onClick={() => onChange("grid")}
      >
        <Grid size={18} />
        Icono
      </ToggleButton>
    </ToggleContainer>
  );
}

export default CustomToggleTabs;